import { createSignal, onCleanup } from "solid-js";
import styles from "./AudioRecorder.module.scss";

export const AudioRecorder = (props: {
  onRecordingComplete: (blob: Blob) => void;
  maxDuration?: number; // in seconds
  onTimerUpdate?: (seconds: number) => void;
}) => {
  const [recording, setRecording] = createSignal(false);
  const [audioUrl, setAudioUrl] = createSignal<string | null>(null);
  const [duration, setDuration] = createSignal(0);
  const [isPlaying, setIsPlaying] = createSignal(false);

  let mediaRecorder: MediaRecorder | null = null;
  let audioChunks: Blob[] = [];
  let timerInterval: number | null = null;

  const startTimer = () => {
    setDuration(0);
    timerInterval = window.setInterval(() => {
      setDuration((prev) => {
        const next = prev + 1;
        props.onTimerUpdate?.(next);
        if (props.maxDuration && next >= props.maxDuration) {
          stopRecording();
        }
        return next;
      });
    }, 1000);
  };

  const stopTimer = () => {
    if (timerInterval !== null) {
      clearInterval(timerInterval);
      timerInterval = null;
    }
  };

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

      const mimeType = MediaRecorder.isTypeSupported("audio/mp4")
        ? "audio/mp4"
        : MediaRecorder.isTypeSupported("audio/webm")
          ? "audio/webm"
          : "";

      if (!mimeType) {
        // notify("No supported audio format found.", { type: "error" });
        return;
      }

      mediaRecorder = new MediaRecorder(stream, { mimeType });
      audioChunks = [];

      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          audioChunks.push(event.data);
        }
      };

      mediaRecorder.onstop = () => {
        const blob = new Blob(audioChunks, { type: mimeType });
        const url = URL.createObjectURL(blob);

        // if (audioUrl()) {
        //   URL.revokeObjectURL(audioUrl());
        // }

        // setAudioUrl(url);
        props.onRecordingComplete(blob);
        stopTimer();
        stream.getTracks().forEach((t) => t.stop());
      };

      mediaRecorder.start();
      setRecording(true);
      startTimer();
    } catch (err) {
      console.error("Failed to start recording:", err);
      // notify("Microphone access denied or not supported.", { type: "error" });
    }
  };

  const stopRecording = () => {
    if (mediaRecorder && recording()) {
      mediaRecorder.stop();
      setRecording(false);
    }
  };

  const toggleRecording = async () => {
    if (recording()) {
      stopRecording();
    } else {
      startRecording();
    }
  };

  onCleanup(() => {
    stopTimer();
    if (mediaRecorder && mediaRecorder.state !== "inactive") {
      mediaRecorder.stop();
    }

    if (audioUrl()) {
      URL.revokeObjectURL(audioUrl()!);
    }
  });

  return (
    <div class={styles["voice-recorder"]}>
      <div class={styles["main-button"]}>
        <button
          type="button"
          classList={{
            [styles["record-button"]]: true,
            [styles["recording"]]: recording(),
          }}
          onClick={toggleRecording}
        >
          <div class={styles["indicator"]}></div>
        </button>

        <p
          classList={{
            [styles["duration"]]: true,
            [styles["active"]]: recording(),
          }}
        >
          {duration()}s
        </p>
      </div>
    </div>
  );
};
